import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';

let isLast = false;

class Subscribe extends React.Component <{}, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      page: 1,
      pageSize: 15,
      env: '',
    };
  }

  public loadBtn = true;

  public componentDidMount() {
    this._getData();
    const _THIS = this;

    this.setState({
      env: (!process.env.REACT_APP_PROJECT_ENV && process.env.NODE_ENV === 'production') ? true : false,
    })

    window.onscroll = function() {
        if(document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50||document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
            if(!_THIS.loadBtn){
                return ;
            }
            // (document.querySelector('#loading') as HTMLElement).style.display = 'block';
            _THIS.setState({
                page: _THIS.state.page + 1,
            }, () => {
                if (_THIS.loadBtn) {
                    _THIS._getData();
                }
            });
        }
    }
    
  }

  render() {
    const { dataList } = this.state;

    return (
      <div>
        {
            this.state.dataList.length > 0 ?
            <div>
              <ul className="subscribe">
                {
                  dataList.map((v: any, k: number) => {
                    return (
                      <li key={k}>
                        <div className="subscribe-box"><p className="subscribe-name">{v.lbelName}</p><p className="subscribe-date">到期时间：{ this.getTime(v.endTime) }</p></div>
                        <button style={{ border: 0, color: '#333' }}>已订阅</button>
                      </li>
                    )
                  })
                }
              </ul>
              { isLast ? '' : <div className="purchaseloading" id="loading"><img src="images/gif.gif" /><span>正在加载...</span></div> }
            </div> : ''
        }

        {
            this.state.dataList.length <= 0 ?
            <div className="upgrade">
              <div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>您没有订阅任何节目</p></div>
              <div className="upgrade-btm">
                    <div className="upgrade-btn"><a href="javascript:;" className="release" onClick={() => window.location.href = `${(this.state.env) ? '//www.ibuychem.com/member/index.html' : '//www-stg.ibuychem.com/member/index.html' }`   }>去订阅</a></div>
                </div>
            </div> : ''
        }
      </div>
    );
  }

  private getTime(time: number) {
    if(!time) {
      return ''
    }

    var date = new Date(time);
    var year  = date.getFullYear();
    var month = date.getMonth() +1;
    var day = date.getDate();
    
    return year + '-' + month + '-' + day;


  }

  private  async _getData() {
    if(!this.loadBtn) {
        return ;
    }

    this.loadBtn = false;

    const r = await request({
        method: 'post',
        data: {
          pageNum: this.state.page,
          pageSize: this.state.pageSize,
        },
        url: `${config.API2}member/subscribe/list`,
    })


    if(r.code === 1) {
        if(r.obj.isLastPage) {
            this.loadBtn = false;
            isLast = true;
        }else {
            this.loadBtn = true;
        }

        this.setState({
          dataList: this.state.dataList.concat( r.obj.list),
        })
    }
  }
}

export default Subscribe;
